import React, { useState, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import ComingSoon from "./ComingSoon";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Solution from "./pages/Solution";
import PVT from "./pages/PVT";
import Blog from "./pages/Blog";
import ContactUs from "./pages/ContactUs";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const isComingSoonEnabled =
    import.meta.env.VITE_COMING_SOON_ENABLED === "true";

  useEffect(() => {
    const checkAuth = () => {
      const isAuth = localStorage.getItem("isAuthenticated") === "true";
      setIsAuthenticated(isAuth);
    };

    checkAuth();
  }, []);

  if (isComingSoonEnabled && !isAuthenticated) {
    return (
      <ComingSoon
        onAuthenticated={(value) => {
          setIsAuthenticated(value);
          if (value) localStorage.setItem("isAuthenticated", "true");
        }}
      />
    );
  }

  return (
    <Router>
      <Layout>
        <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/solution" element={<Solution />} />
            <Route path="/pvt" element={<PVT />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default React.memo(App);
